import api from '../../apiConfig/apiConfig'
import { Post, Get, Patch, Delete } from '../base/baseAjax'

let visitorDataStats = (param) => {
  return Post({
    url: api.visitor.visitorDataStats,
    bodyParam: param,
  })
}
let visitorDetails = (param) => {
  return Get({
    url: api.visitor.visitorDetails,
    PathParam: param,
  })
}

let dataExport = (param) => {
  return Post({
    url: api.visitor.dataExport,
    bodyParam: param,
    config: {
      timeout: 60000,
      responseType: 'blob',
    },
  })
}
let visitorStaff = (param) => {
  return Post({
    url: api.visitor.visitorStaff,
    bodyParam: param,
    config: {
      timeout: 1000 * 60 * 3,
    },
  })
}
let visitorStaffList = (param) => {
  return Post({
    url: api.visitor.visitorStaffList,
    bodyParam: param,
  })
}
let visitorStaffTotal = (param) => {
  return Post({
    url: api.visitor.visitorStaffTotal,
    bodyParam: param,
  })
}
export default {
  visitorDataStats,
  visitorDetails,
  dataExport,
  visitorStaff,
  visitorStaffList,
  visitorStaffTotal,
}
